import cn from 'classnames'
import s from './Sidebar.module.scss'
import Portal from '@reach/portal'
import { FC, useEffect, useRef } from 'react'
import {
    disableBodyScroll,
    enableBodyScroll,
    clearAllBodyScrollLocks
} from 'body-scroll-lock'

interface Props {
    children: unknown
    open: boolean
    onClose: () => void
}

const Sidebar: FC<Props> = ({ children, open = false, onClose }) => {
    const ref = useRef() as React.MutableRefObject<HTMLDivElement>

    useEffect(() => {
        if (ref.current) {
            if (open) {
                disableBodyScroll(ref.current)
            } else {
                enableBodyScroll(ref.current)
            }
        }
        return () => {
            clearAllBodyScrollLocks()
        }
    }, [open])

    return (
        <Portal>
            {open ? (
                <div className={cn(s.root, 'animate-fade-in-right')}>
                    <div className={cn(s['sidebar-main'], 'sidebar-main')}>
                        <div
                            className={s['sidebar-overlay']}
                            onClick={onClose}
                            onKeyDown={onClose}
                            role="button"
                            tabIndex={0}
                        />
                        <section
                            className={cn(
                                s['sidebar-container'],
                                'sidebar-container'
                            )}
                        >
                            <div
                                className={s['sidebar-container-inner-wrapper']}
                            >
                                <div
                                    className={s['sidebar-container-inner']}
                                    ref={ref}
                                >
                                    {children}
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            ) : null}
        </Portal>
    )
}

export default Sidebar
